import BaseSvg, { Props } from '../BaseSvg'

const Location: React.FC<Props> = (props) => (
  <BaseSvg {...props}>
    <path
      clipRule="evenodd"
      d="M8.87585 1.8335C11.8564 1.8335 15.0134 4.09628 15.0134 7.97106C15.0134 11.4931 9.82823 15.1668 8.87585 15.1668C7.92347 15.1668 2.73828 11.4988 2.73828 7.97106C2.73828 4.09628 5.89526 1.8335 8.87585 1.8335ZM8.87585 3.50016C6.45358 3.50016 4.40495 5.3517 4.40495 7.97106C4.40495 8.9925 5.22349 10.3649 6.6038 11.6892C7.19231 12.2539 7.83913 12.7652 8.41697 13.137C8.56335 13.2312 8.6993 13.3124 8.81909 13.3782L8.87501 13.4077L8.93182 13.3781C9.01168 13.3343 9.09874 13.2835 9.19128 13.2266L9.33401 13.1367C9.91185 12.7644 10.5589 12.2525 11.1476 11.6874C12.5279 10.3623 13.3467 8.98988 13.3467 7.97106C13.3467 5.3517 11.2981 3.50016 8.87585 3.50016ZM8.87584 6.00016C9.79632 6.00016 10.5425 6.74635 10.5425 7.66683C10.5425 8.5873 9.79632 9.3335 8.87584 9.3335C7.95537 9.3335 7.20917 8.5873 7.20917 7.66683C7.20917 6.74635 7.95537 6.00016 8.87584 6.00016Z"
      fillRule="evenodd"
    />
  </BaseSvg>
)

export default Location
